import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProcesosEmpresasModal, { type ProcesosEmpresaRow } from './ProcesosEmpresasModal';
import { empresaProcesosLabel, procesosEmpresaWorkflowsPath } from './procesos-empresa-routes';
import { readProcesosReturnSearch, type ProcesosWorkflowLocationState } from './procesos-workflow-routes';

export default function ProcesosEmpresasModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as ProcesosWorkflowLocationState | null;
  const procesosReturnSearch = readProcesosReturnSearch(state);
  const returnPath = state?.returnPath || '/procesos';

  const handleClose = useCallback(() => {
    navigate(`${returnPath}${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleSelectEmpresa = useCallback((empresa: ProcesosEmpresaRow) => {
    navigate(procesosEmpresaWorkflowsPath(empresa.id, procesosReturnSearch), {
      state: {
        procesosSearch: procesosReturnSearch,
        returnPath,
        empresaLabel: empresaProcesosLabel(empresa) || `Empresa #${empresa.id}`,
      },
    });
  }, [navigate, procesosReturnSearch, returnPath]);

  return (
    <ProcesosEmpresasModal
      open
      onClose={handleClose}
      onSelectEmpresa={handleSelectEmpresa}
    />
  );
}
